var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E50B20",
    d: "M32 64c17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E50B20",
    d: "M19.78 19.78c.704-.703 1.818-.774 2.603-.176l.202.177L32 29.197l9.415-9.416c.722-.723 1.864-.771 2.643-.145l.161.145c.704.704.775 1.817.158 2.625l-.158.18L34.803 32l9.416 9.415c.723.723.771 1.864.145 2.643l-.145.161c-.704.704-1.817.775-2.625.158l-.18-.158-9.416-9.416-9.413 9.416c-.723.723-1.864.771-2.643.145l-.161-.145c-.704-.703-.775-1.817-.158-2.625l.158-.18L29.195 32l-9.414-9.415c-.723-.722-.771-1.864-.145-2.643l.145-.161z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteModalIcon);
export default __webpack_public_path__ + "static/media/delete-modal-icon.a2b29ae883d6e91da3ae6c4f0acaca6b.svg";
export { ForwardRef as ReactComponent };